"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["value", "minValue", "maxValue", "valueLabels", "largeValueLabels", "hideValueBar", "step", "onChange", "onDragEnd", "className", "disabled"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Slider = function Slider(props) {
  var value = props.value,
    minValue = props.minValue,
    maxValue = props.maxValue,
    valueLabels = props.valueLabels,
    largeValueLabels = props.largeValueLabels,
    hideValueBar = props.hideValueBar,
    step = props.step,
    onChange = props.onChange,
    onDragEnd = props.onDragEnd,
    className = props.className,
    disabled = props.disabled,
    remainingProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(value ? value : minValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currentValue = _useState2[0],
    setCurrentValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isChanging = _useState4[0],
    setIsChanging = _useState4[1];
  (0, _react.useEffect)(function () {
    if (value >= minValue && value <= maxValue) {
      setCurrentValue(value);
    }
  }, [value, minValue, maxValue]);
  var handleChange = function handleChange(event) {
    var newValue = parseInt(event.target.value, 10);
    setCurrentValue(newValue);
    setIsChanging(true);
    onChange(newValue);
  };
  var onMouseUp = function onMouseUp() {
    setIsChanging(false);
    onDragEnd(currentValue);
  };
  var onMouseDown = function onMouseDown() {
    setIsChanging(true);
  };
  var classNames = (0, _classnames["default"])('range-slider', disabled && 'disabled', valueLabels && 'show-value-labels', hideValueBar && 'hide-value-bar', largeValueLabels && 'large-value-labels', className && className);
  var trackWidth = 100 * (currentValue - minValue) / (maxValue - minValue);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, remainingProps, {
    className: classNames
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "range-whole-track"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "range-track",
    style: {
      width: "".concat(trackWidth, "%")
    }
  }, valueLabels && /*#__PURE__*/_react["default"].createElement("div", {
    className: "range-value"
  }, currentValue)), /*#__PURE__*/_react["default"].createElement("input", {
    className: "".concat(isChanging ? 'changing' : ''),
    value: currentValue,
    min: minValue,
    max: maxValue,
    step: step,
    type: "range",
    onChange: handleChange,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp
  }));
};
Slider.defaultProps = {
  step: 1,
  value: 0,
  minValue: 0,
  maxValue: Number.MAX_VALUE,
  valueLabels: false,
  hideValueBar: false,
  disabled: false,
  onChange: function onChange() {},
  onDragEnd: function onDragEnd() {}
};
Slider.propTypes = {
  value: _propTypes["default"].number,
  minValue: _propTypes["default"].number.isRequired,
  maxValue: _propTypes["default"].number.isRequired,
  valueLabels: _propTypes["default"].bool,
  largeValueLabels: _propTypes["default"].bool,
  hideValueBar: _propTypes["default"].bool,
  step: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  onDragEnd: _propTypes["default"].func,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
};
var _default = Slider;
exports["default"] = _default;